import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { FileText, TrendingDown, CircleOff } from 'lucide-react';
const problems = [{
  icon: FileText,
  title: 'Wissen ohne Umsetzung',
  description: '87% der deutschen Unternehmen haben KI-Strategie-Dokumente. Weniger als 12% haben funktionierende Prototypen in Produktion.'
}, {
  icon: TrendingDown,
  title: 'Teure Beratung, wenig Output',
  description: 'Klassische Consulting-Projekte kosten 200.000€+ und liefern Slide-Decks. Ihre Mitarbeiter können danach nicht mehr als vorher.'
}, {
  icon: CircleOff,
  title: 'Isolation im eigenen Saft',
  description: 'Interne Teams drehen sich im Kreis. Ohne externe Impulse, ohne Sparring, ohne Zugang zu Experten, die es schon 50 Mal gemacht haben.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export function ProblemSection() {
  return <section id="problem" className="py-24 md:py-32 bg-[#020611]" data-id="element-276">
      <div className="container mx-auto px-6" data-id="element-277">
        <div className="mb-16 md:mb-24" data-id="element-278">
          <div className="w-12 h-1 bg-accent mb-6" data-id="element-279" />
          <h2 className="text-3xl md:text-5xl font-heading" data-id="element-280">
            Die Realität in deutschen Unternehmen
          </h2>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-281">
          {problems.map((problem, index) => <motion.div key={index} variants={itemVariants} className="bg-surface border border-border p-8 hover:border-border-hover transition-colors group" data-id="element-282">
              <div className="w-12 h-12 bg-[#020611] border border-border flex items-center justify-center mb-6 group-hover:border-accent/50 transition-colors" data-id="element-283">
                <problem.icon className="text-accent" size={24} data-id="element-284" />
              </div>
              <h3 className="text-xl font-heading font-semibold mb-4 text-foreground" data-id="element-285">
                {problem.title}
              </h3>
              <p className="text-muted leading-relaxed" data-id="element-286">
                {problem.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}